import React from 'react';

const FeatureCard = ({ iconSrc, title, children }) => {
  return (
    <div className=" p-8 text-left    flex-col ">
      <div className="w-16 h-16 flex items-center justify-center mb-4 rounded-full">
        <img src={iconSrc} className="h-14 w-14 opacity-90" />
      </div>
      <h4 className="text-zinc-50 mb-4 text-2xl font-semibold ">
        {title}
      </h4>
      <p className="text-lg text-zinc-400 leading-relaxed flex-1  ">
        {children}
      </p>
    </div>
  );
};

export default FeatureCard; 